/**
 * Shared attachment vocabulary — the bits both channel messages and task
 * comments need, neither of which owns the other.
 *
 * Structural rather than tied to an entity: the two stores disagree on almost
 * every column (a channel row carries a Box discriminator, a task comment row
 * does not) but agree on the only two fields any of this reads.
 */

/** The minimum a row must carry to decide how — and whether — to preview it. */
export interface IAttachmentPreviewMeta {
  mimeType: string | null
  sizeBytes: number | null
}

/**
 * Attachments whose mime type is in this set render inline rather than as a
 * filename chip. Only S3-backed ones can: a Box embed URL is a short-lived
 * iframe preview, not something `<img src>` can load.
 */
export const isInlineRenderableImage = (mimeType: string | null): boolean =>
  !!mimeType && mimeType.startsWith('image/')

/** Video attachments open in a player; only Team Messaging accepts them. */
export const isVideoAttachment = (mimeType: string | null): boolean =>
  !!mimeType && mimeType.startsWith('video/')
